module.exports = __webpack_public_path__ + "img/presales.75b9644d.png";